<template>
  <TooltipIconButton
    icon="mdi-archive"
    :tooltipText="tooltipText"
    :color="color"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'ArchiveButton',
  props: {
    color: {
      type: String,
      default: 'red',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: 'tooltip.archive',
    },
  },
}
</script>
